// import React, { useState } from "react";
// import {
//   Box,
//   Button,
//   Container,
//   TextField,
//   Typography,
//   InputAdornment,
//   Paper,
//   AppBar,
//   Toolbar,
//   IconButton,
// } from "@mui/material";
// import {
//   AccountCircle,
//   Lock,
//   Person,
//   Phone,
//   LocationCity,
//   DirectionsBike,
//   Visibility,
//   VisibilityOff,
// } from "@mui/icons-material";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import Grocerylogo from "../../images/Grocerylogo.png";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Header2 from "../../Component/Header2";
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

// const DeliveryBoyRegistrationForm = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     mobileNumber: "",
//     city: "",
//     username: "",
//     password: "",
//   });

//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const shopkeeperId = localStorage.getItem("shopkeeperID");
// const handleChange = (e) =>
//     setFormData({ ...formData, [e.target.name]: e.target.value });

// const handleRegister = async (e) => {
//   e.preventDefault();

//   const { name, mobileNumber, city, username, password } = formData;
//   if (!name || !mobileNumber || !city || !username || !password) {
//     toast.error("❗ Please fill in all fields before submitting.");
//     return;
//   }

//   try {
//     const res = await axios.post("https://sakhisshop.com/api/deliveryboys", {
//       ...formData,
//       shopkeeperId,
//     });

//     if (res.data && res.data.error) {
//       // ❌ Backend says DeliveryBoy creation is disabled
//       toast.error(res.data.error);
//       return;
//     }

//     // ✅ Success
//     toast.success("Delivery Boy Registered Successfully!");
//     setFormData({
//       name: "",
//       mobileNumber: "",
//       city: "",
//       username: "",
//       password: "",
//     });
//   } catch (error) {
//     let msg = "❌ Registration failed. Please try again.";
//     if (error.response && error.response.data && error.response.data.error) {
//       msg = error.response.data.error;
//     }
//     toast.error(msg);
//   }
// };

//   return (

//     <Box
//       sx={{
//         minHeight: "100vh",
//         background: "linear-gradient(to right, #f0f4c3, #e3f2fd)",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     >
//       {/* Toast */}
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

//       <Header2/>

//       {/* Main Form Content */}
//       <Container
//         maxWidth="sm"
//         sx={{
//           mt: 12,
//           mb: 4,
//           flexGrow: 1,
//           display: "flex",
//           alignItems: "center",
//         }}
//       >
//         <Paper elevation={5} sx={{ p: 3, borderRadius: 2, width: "100%" }}>
//           <Box textAlign="center" mb={3}>
//             <IconButton onClick={() => navigate(-1)} color="warning">
//                   <ArrowBackIosNewIcon />
//                 </IconButton>

//             <DirectionsBike sx={{ fontSize: 40, color: "#1976d2" }} />
//             <Typography variant="h6" fontWeight="bold" color="primary">
//               Delivery Boy Registration
//             </Typography>
//           </Box>

//           <TextField
//             fullWidth
//             margin="normal"
//             name="name"
//             label="Name"
//             value={formData.name}
//             onChange={handleChange}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <Person />
//                 </InputAdornment>
//               ),
//             }}
//           />

//           <TextField
//             fullWidth
//             margin="normal"
//             name="mobileNumber"
//             label="Mobile Number"
//             value={formData.mobileNumber}
//             onChange={handleChange}
//             inputProps={{ maxLength: 10, pattern: "[0-9]*" }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <Phone />
//                 </InputAdornment>
//               ),
//             }}
//           />

//           <TextField
//             fullWidth
//             margin="normal"
//             name="city"
//             label="City"
//             value={formData.city}
//             onChange={handleChange}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <LocationCity />
//                 </InputAdornment>
//               ),
//             }}
//           />

//           <TextField
//             fullWidth
//             margin="normal"
//             name="username"
//             label="Username"
//             value={formData.username}
//             onChange={handleChange}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <AccountCircle />
//                 </InputAdornment>
//               ),
//             }}
//           />

//           <TextField
//             fullWidth
//             margin="normal"
//             name="password"
//             label="Password"
//             type={showPassword ? "text" : "password"}
//             value={formData.password}
//             onChange={handleChange}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <Lock />
//                 </InputAdornment>
//               ),
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
//                     {showPassword ? <VisibilityOff /> : <Visibility />}
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//           />

//           <Button
//             fullWidth
//             variant="contained"
//             sx={{ mt: 3, py: 1.5 }}
//             onClick={handleRegister}
//           >
//             REGISTER
//           </Button>

//           <Box mt={3} textAlign="center">
//             <Typography variant="body2">Already have an account?</Typography>
//             <Button
//               variant="contained"
//               size="small"
//               sx={{ mt: 1 }}
//               onClick={() => navigate("/deliveryBoyLogin")}
//             >
//               Login
//             </Button>
//           </Box>
//         </Paper>
//       </Container>

//       {/* Footer */}

//     </Box>
//   );
// };

// export default DeliveryBoyRegistrationForm;

import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  InputAdornment,
  Paper,
  AppBar,
  Toolbar,
  IconButton,
} from "@mui/material";
import {
  AccountCircle,
  Lock,
  Person,
  Phone,
  LocationCity,
  DirectionsBike,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Grocerylogo from "../../images/Grocerylogo.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header2 from "../../Component/Header2";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const DeliveryBoyRegistrationForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobileNumber: "",
    city: "",
    username: "",
    password: "",
  });

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [usernameError, setUsernameError] = useState("");

  const shopkeeperId = localStorage.getItem("shopkeeperID");

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleRegister = async (e) => {
    e.preventDefault();

    const { name, mobileNumber, city, username, password } = formData;
    if (!name || !mobileNumber || !city || !username || !password) {
      toast.error("❗ Please fill in all fields before submitting.");
      return;
    }

    try {
      const res = await axios.post("https://sakhisshop.com/api/deliveryboys", {
        ...formData,
        shopkeeperId,
      });

      if (res.data && res.data.error) {
        // ❌ Backend says DeliveryBoy creation is disabled
        toast.error(res.data.error);
        return;
      }

      // ✅ Success
      toast.success("Delivery Boy Registered Successfully!");
      setFormData({
        name: "",
        mobileNumber: "",
        city: "",
        username: "",
        password: "",
      });
    } catch (err) {
      const backendMessage =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        "Registration error. Please try again.";

      // Inline only for username error
      if (backendMessage.toLowerCase().includes("username")) {
        setUsernameError(backendMessage); // show under field
        return; // prevent alert/popup
      }

      // Show popup for all other errors
      toast.error(backendMessage);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(to right, #f0f4c3, #e3f2fd)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Toast */}
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

      <Header2 />

      {/* Main Form Content */}
      <Container
        maxWidth="sm"
        sx={{
          mt: 12,
          mb: 4,
          flexGrow: 1,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Paper elevation={5} sx={{ p: 3, borderRadius: 2, width: "100%" }}>
          <Box textAlign="center" mb={3}>
            <IconButton onClick={() => navigate(-1)} color="warning">
              <ArrowBackIosNewIcon />
            </IconButton>

            <DirectionsBike sx={{ fontSize: 40, color: "#1976d2" }} />
            <Typography variant="h6" fontWeight="bold" color="primary">
              Delivery Boy Registration
            </Typography>
          </Box>

          <TextField
            fullWidth
            margin="normal"
            name="name"
            label="Name"
            value={formData.name}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Person />
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            margin="normal"
            name="mobileNumber"
            label="Mobile Number"
            value={formData.mobileNumber}
            onChange={handleChange}
            inputProps={{ maxLength: 10, pattern: "[0-9]*" }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Phone />
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            margin="normal"
            name="city"
            label="City"
            value={formData.city}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LocationCity />
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            margin="normal"
            name="username"
            label="Username"
            value={formData.username}
            onChange={(e) => {
              handleChange(e);
              setUsernameError(""); // clear inline error while typing
            }}
            error={!!usernameError} // ✅ highlights field in red if error exists
            helperText={usernameError} // ✅ shows inline message
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            margin="normal"
            name="password"
            label="Password"
            type={showPassword ? "text" : "password"}
            value={formData.password}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Lock />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button
            fullWidth
            variant="contained"
            sx={{ mt: 3, py: 1.5 }}
            onClick={handleRegister}
          >
            REGISTER
          </Button>

          <Box mt={3} textAlign="center">
            <Typography variant="body2">Already have an account?</Typography>
            <Button
              variant="contained"
              size="small"
              sx={{ mt: 1 }}
              onClick={() => navigate("/deliveryBoyLogin")}
            >
              Login
            </Button>
          </Box>
        </Paper>
      </Container>

      {/* Footer */}
    </Box>
  );
};

export default DeliveryBoyRegistrationForm;
